import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'
// import loggerMiddleware from 'redux-logger'
import reducers from '../reducers'

export default function configureStore (initialState) {
  let store
  if (process.env.NODE_ENV !== 'production') {
    store = (composeWithDevTools(applyMiddleware(
      thunkMiddleware
      // loggerMiddleware
    ))(createStore))(reducers, initialState)
  } else {
    store = (applyMiddleware(
      thunkMiddleware
    )(createStore))(reducers, initialState)
  }
  return store
}



// WEBPACK FOOTER //
// ./src/stores/configureStore.js